import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui';
const workbooks = [{
  title: 'Coordinación Motora',
  pages: '30 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Coordinacion_Motora_Grafismo.png?v=1780592902',
  color: 'bg-blue-100'
}, {
  title: 'Cursiva',
  pages: '29 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/ChatGPT_Image_29_may_2026_15_25_15.png?v=1780592902',
  color: 'bg-pink-100'
}, {
  title: 'Imprenta',
  pages: '27 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Abecedario_en_imprenta.png?v=1780592902',
  color: 'bg-yellow-100'
}, {
  title: 'Multiplicación y División',
  pages: '27 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Matematica_-_Multiplicacion_y_division.png?v=1780592902',
  color: 'bg-green-100'
}, {
  title: 'Suma y Resta',
  pages: '23 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Matematicas_-_SUMAS_Y_RESTAS.png?v=1780592902',
  color: 'bg-orange-100'
}, {
  title: 'Vocales',
  pages: '7 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/VOCALES.png?v=1780592902',
  color: 'bg-purple-100'
}, {
  title: 'Formación de Palabras',
  pages: '57 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/FORMAR_PALABRAS.png?v=1780592902',
  color: 'bg-blue-100'
}, {
  title: 'Formación de Sílabas',
  pages: '60 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/SILABAS.png?v=1780592902',
  color: 'bg-pink-100'
}, {
  title: 'Cantidades y Números',
  pages: '42 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Cantidades_y_Numero.png?v=1780592902',
  color: 'bg-yellow-100'
}, {
  title: 'Punteado y Líneas',
  pages: '25 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Punteado_y_lineas.png?v=1780592902',
  color: 'bg-green-100'
}, {
  title: 'Colores y Formas',
  pages: '35 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Colores_y_Formas.png?v=1780592903',
  color: 'bg-orange-100'
}, {
  title: 'Coloreando',
  pages: '80 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Coloreando_80.png?v=1780592902',
  color: 'bg-purple-100'
}, {
  title: 'Cuadernillo de Juegos',
  pages: '45 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Cuadernillo_de_juegos.png?v=1780592903',
  color: 'bg-blue-100'
}, {
  title: 'Lecturitas',
  pages: '50 páginas',
  img: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Cuadernillo_de_lecturas.png?v=1780592904',
  color: 'bg-pink-100'
}];
export const KitCatalog = () => {
  return <section className="py-20 bg-white" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        <SectionHeading subtitle="Explora los 14 cuadernillos que componen esta colección premium." data-id="element-239">
          ¿Qué incluye el kit?
        </SectionHeading>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8" data-id="element-240">
          {workbooks.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 4 * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-white rounded-3xl overflow-hidden shadow-soft border border-slate-100 group" data-id="element-241">
              <div className={`h-48 ${item.color} p-4 flex items-center justify-center relative overflow-hidden`} data-id="element-242">
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-243" />
                <img src={`${item.img}&width=400&quality=80&format=webp`} alt={item.title} width="400" height="400" loading="lazy" decoding="async" className="h-full w-auto object-contain drop-shadow-xl group-hover:scale-105 transition-transform duration-300" data-id="element-244" />
              </div>
              <div className="p-5 text-center" data-id="element-245">
                <h3 className="font-heading text-xl text-brand-navy mb-2 line-clamp-1" data-id="element-246">
                  {item.title}
                </h3>
                <span className="inline-block bg-slate-100 text-slate-600 text-sm font-semibold px-3 py-1 rounded-full" data-id="element-247">
                  {item.pages}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};